import { Box } from "@mui/material";

export default function ApplicationDetailsLayoutContainer({ children }: any) {
  return <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>{children}</Box>;
}
